import { handlers as graphqlHandlers } from "./graphql";
import { handlers as restHandlers } from "./rest";

export const handlers = [
    ...graphqlHandlers,
    ...restHandlers,
];

